import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import BannerComponent from '../../components/layout/banner/main';
import LiveNewsTicker from '../../components/layout/live-news-ticker';
import PopularPosts from '../../components/widget/sidebar/popular-posts';
import LiveStreams from '../../components/widget/sidebar/live-streams';
import FeaturedVideo from '../../components/widget/sidebar/featured-video';
import TagCloud from '../../components/widget/sidebar/tag-cloud';
import SidebarSearch from '../../components/widget/sidebar/search';
import PostPreview from '../../components/layout/post-preview';
import Pagination from '../../components/pagination';
import { pageTitle } from 'ember-page-title';

class NewsIndexComponent extends Component {
  <template>
    {{pageTitle 'Gaming News'}}
    <BannerComponent @theme='gaming-news' @title='Gaming News' />
    <LiveNewsTicker />
    <div class='layout-content-1 layout-item-3-1 grid-limit'>
      <div class='layout-body'>
        <div class='layout-item gutter-big'>
          {{#each @model.articles as |article|}}
            <PostPreview @type='gaming-news' @post={{article}} />
          {{/each}}
        </div>
        <Pagination
          @currentPage={{@model.pagination.currentPage}}
          @totalCount={{@model.pagination.totalCount}}
          @limit={{@model.pagination.limit}}
          @hasPreviousPage={{@model.pagination.hasPreviousPage}}
          @hasNextPage={{@model.pagination.hasNextPage}}
          @route='news.index'
        />
      </div>
      <div class='layout-sidebar layout-item gutter-medium'>
        <SidebarSearch />
        <PopularPosts @articles={{@model.popularPosts}} />
        <LiveStreams />
        <FeaturedVideo />
      </div>
    </div>
  </template>
}
export default RouteTemplate(NewsIndexComponent);
